// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__2LsQP","header":"styles_header__iyju2","contentWrapper":"styles_contentWrapper__GfXc3","open":"styles_open__8gU4R","content":"styles_content__HH0LT"};